export function initializeCatalogSelectors ({
    event_type = 'change',
    catalog_parent_query_selector = 'main',
    catalog_selector_query_selector = 'input[type=radio].catalog-selector',
    escape_selection_and_deselection_query_selector = '.catalog-selector-wrapper',
    display_none_class = 'd-none',
    target_data_attribute_key = 'sku',
}) {
    const catalog_selectors = document.querySelectorAll(catalog_selector_query_selector);

    catalog_selectors.forEach(catalog_selector => {
        catalog_selector.addEventListener(event_type, event => {
            const catalog_parent = document.querySelector(catalog_parent_query_selector);
            const selected_catalog_selector = event.currentTarget;
            const target_data_attribute_value = selected_catalog_selector.dataset[target_data_attribute_key];

            /**
             * Show selected elements:
             * - which has data attribute that matches the target key AND value; and
             * - are not catalog selectors
             */
            const selected_elements_query_selector = `[data-${target_data_attribute_key}=${target_data_attribute_value}]:not(${catalog_selector_query_selector}, ${escape_selection_and_deselection_query_selector})`;
            const selected_elements = catalog_parent.querySelectorAll(selected_elements_query_selector);
            /**
             * Hide deselected elements:
             * - which has data attribute that matches the target key; BUT
             * - the data attribute with the target key does not has the target value; and
             * - which are not catalog selectors
             */
            const deselected_elements_query_selector = `[data-${target_data_attribute_key}]:not([data-${target_data_attribute_key}=${target_data_attribute_value}]):not(${catalog_selector_query_selector}, ${escape_selection_and_deselection_query_selector})`;
            const deselected_elements = catalog_parent.querySelectorAll(deselected_elements_query_selector);

            selected_elements.forEach(selected_element => {
                selected_element.classList.remove(display_none_class);
            });

            deselected_elements.forEach(deselected_elements => {
                deselected_elements.classList.add(display_none_class);
            });
        });
    });
}
